"use client";
import { createGlobalStyle } from "styled-components";
import { globalTextStyles } from "../../foundation/typography/index.js";
const RegisterMollerBilTheme = createGlobalStyle`
    .theme-moller-bil {
  --moller-opacity-on-focus: 0.16;
  --moller-opacity-on-pressed: 0.16;
  --moller-opacity-on-hover: 0.08;
  --moller-opacity-percentage-16: 0.16;
  --moller-opacity-percentage-8: 0.08;
  --moller-elevation-high: 0px 0px 1px 0px #0000003d, 0px 2px 16px 0px #00000014, 0px 8px 48px 0px #0000000f;
  --moller-elevation-medium: 0px 0px 1px 0px #0000003d, 0px 4px 8px 0px #0000000a, 0px 8px 24px 0px #0000000f;
  --moller-elevation-low: 0px 0px 1px 0px #0000003d, 0px 1px 4px 0px #0000000a, 0px 4px 8px 0px #0000000f;
  --moller-elevation-none: 0px 0px 0px 0px #00000000;
  --moller-border-radius-full: 999px;
  --moller-border-radius-xx-large: 16px;
  --moller-border-radius-x-large: 12px;
  --moller-border-radius-large: 8px;
  --moller-border-radius-medium: 4px;
  --moller-border-radius-small: 2px;
  --moller-border-radius-none: 0px;
  --moller-stroke-large: 4px;
  --moller-stroke-medium: 2px;
  --moller-stroke-small: 1px;
  --moller-stroke-x-small: 0.5px;
  --moller-type-compact-notice-text-case: none;
  --moller-type-compact-notice-text-decoration: none;
  --moller-type-compact-notice-paragraph-spacing: 0.75rem;
  --moller-type-compact-notice-letter-spacing: 0;
  --moller-type-compact-notice-font-size: 0.75rem;
  --moller-type-compact-notice-line-height: 1.4;
  --moller-type-compact-notice-font-weight: 500;
  --moller-type-compact-notice-font-family: Moller;
  --moller-type-compact-label-text-case: none;
  --moller-type-compact-label-text-decoration: none;
  --moller-type-compact-label-paragraph-spacing: 0.625rem;
  --moller-type-compact-label-letter-spacing: 0;
  --moller-type-compact-label-font-size: 0.625rem;
  --moller-type-compact-label-line-height: 1.4;
  --moller-type-compact-label-font-weight: 400;
  --moller-type-compact-label-font-family: Moller;
  --moller-type-compact-action-text-case: none;
  --moller-type-compact-action-text-decoration: none;
  --moller-type-compact-action-paragraph-spacing: 0.875rem;
  --moller-type-compact-action-letter-spacing: 0;
  --moller-type-compact-action-font-size: 0.875rem;
  --moller-type-compact-action-line-height: 1.4;
  --moller-type-compact-action-font-weight: 500;
  --moller-type-compact-action-font-family: Moller;
  --moller-type-small-description-text-case: none;
  --moller-type-small-description-text-decoration: none;
  --moller-type-small-description-paragraph-spacing: 0.75rem;
  --moller-type-small-description-letter-spacing: 0;
  --moller-type-small-description-font-size: 0.75rem;
  --moller-type-small-description-line-height: 1.4;
  --moller-type-small-description-font-weight: 400;
  --moller-type-small-description-font-family: Moller;
  --moller-type-small-link-text-case: none;
  --moller-type-small-link-text-decoration: underline;
  --moller-type-small-link-paragraph-spacing: 1rem;
  --moller-type-small-link-letter-spacing: 0;
  --moller-type-small-link-font-size: 1rem;
  --moller-type-small-link-line-height: 1.4;
  --moller-type-small-link-font-weight: 400;
  --moller-type-small-link-font-family: Moller;
  --moller-type-small-body-text-case: none;
  --moller-type-small-body-text-decoration: none;
  --moller-type-small-body-paragraph-spacing: 1rem;
  --moller-type-small-body-letter-spacing: 0;
  --moller-type-small-body-font-size: 1rem;
  --moller-type-small-body-line-height: 1.4;
  --moller-type-small-body-font-weight: 400;
  --moller-type-small-body-font-family: Moller;
  --moller-type-small-lead-text-case: none;
  --moller-type-small-lead-text-decoration: none;
  --moller-type-small-lead-paragraph-spacing: 1.25rem;
  --moller-type-small-lead-letter-spacing: 0;
  --moller-type-small-lead-font-size: 1.25rem;
  --moller-type-small-lead-line-height: 1.4;
  --moller-type-small-lead-font-weight: 400;
  --moller-type-small-lead-font-family: Moller;
  --moller-type-small-overline-text-case: uppercase;
  --moller-type-small-overline-text-decoration: none;
  --moller-type-small-overline-paragraph-spacing: 1.125rem;
  --moller-type-small-overline-letter-spacing: 0;
  --moller-type-small-overline-font-size: 0.75rem;
  --moller-type-small-overline-line-height: 1.4;
  --moller-type-small-overline-font-weight: 500;
  --moller-type-small-overline-font-family: Moller;
  --moller-type-small-subtitle-text-case: none;
  --moller-type-small-subtitle-text-decoration: none;
  --moller-type-small-subtitle-paragraph-spacing: 1.5rem;
  --moller-type-small-subtitle-letter-spacing: 0;
  --moller-type-small-subtitle-font-size: 1rem;
  --moller-type-small-subtitle-line-height: 1.4;
  --moller-type-small-subtitle-font-weight: 500;
  --moller-type-small-subtitle-font-family: Moller;
  --moller-type-small-headline-text-case: none;
  --moller-type-small-headline-text-decoration: none;
  --moller-type-small-headline-paragraph-spacing: 2.25rem;
  --moller-type-small-headline-letter-spacing: 0;
  --moller-type-small-headline-font-size: 1.5rem;
  --moller-type-small-headline-line-height: 1.4;
  --moller-type-small-headline-font-weight: 500;
  --moller-type-small-headline-font-family: Moller;
  --moller-type-small-display-text-case: none;
  --moller-type-small-display-text-decoration: none;
  --moller-type-small-display-paragraph-spacing: 3rem;
  --moller-type-small-display-letter-spacing: 0;
  --moller-type-small-display-font-size: 2rem;
  --moller-type-small-display-line-height: 1.4;
  --moller-type-small-display-font-weight: 500;
  --moller-type-small-display-font-family: Moller;
  --moller-type-medium-description-text-case: none;
  --moller-type-medium-description-text-decoration: none;
  --moller-type-medium-description-paragraph-spacing: 0.75rem;
  --moller-type-medium-description-letter-spacing: 0;
  --moller-type-medium-description-font-size: 0.75rem;
  --moller-type-medium-description-line-height: 1.4;
  --moller-type-medium-description-font-weight: 400;
  --moller-type-medium-description-font-family: Moller;
  --moller-type-medium-link-text-case: none;
  --moller-type-medium-link-text-decoration: underline;
  --moller-type-medium-link-paragraph-spacing: 1rem;
  --moller-type-medium-link-letter-spacing: 0;
  --moller-type-medium-link-font-size: 1rem;
  --moller-type-medium-link-line-height: 1.4;
  --moller-type-medium-link-font-weight: 400;
  --moller-type-medium-link-font-family: Moller;
  --moller-type-medium-body-text-case: none;
  --moller-type-medium-body-text-decoration: none;
  --moller-type-medium-body-paragraph-spacing: 1rem;
  --moller-type-medium-body-letter-spacing: 0;
  --moller-type-medium-body-font-size: 1rem;
  --moller-type-medium-body-line-height: 1.4;
  --moller-type-medium-body-font-weight: 400;
  --moller-type-medium-body-font-family: Moller;
  --moller-type-medium-lead-text-case: none;
  --moller-type-medium-lead-text-decoration: none;
  --moller-type-medium-lead-paragraph-spacing: 1.5rem;
  --moller-type-medium-lead-letter-spacing: 0;
  --moller-type-medium-lead-font-size: 1.5rem;
  --moller-type-medium-lead-line-height: 1.4;
  --moller-type-medium-lead-font-weight: 400;
  --moller-type-medium-lead-font-family: Moller;
  --moller-type-medium-overline-text-case: uppercase;
  --moller-type-medium-overline-text-decoration: none;
  --moller-type-medium-overline-paragraph-spacing: 1.5rem;
  --moller-type-medium-overline-letter-spacing: 0;
  --moller-type-medium-overline-font-size: 1rem;
  --moller-type-medium-overline-line-height: 1.4;
  --moller-type-medium-overline-font-weight: 500;
  --moller-type-medium-overline-font-family: Moller;
  --moller-type-medium-subtitle-text-case: none;
  --moller-type-medium-subtitle-text-decoration: none;
  --moller-type-medium-subtitle-paragraph-spacing: 1.875rem;
  --moller-type-medium-subtitle-letter-spacing: 0;
  --moller-type-medium-subtitle-font-size: 1.25rem;
  --moller-type-medium-subtitle-line-height: 1.4;
  --moller-type-medium-subtitle-font-weight: 500;
  --moller-type-medium-subtitle-font-family: Moller;
  --moller-type-medium-headline-text-case: none;
  --moller-type-medium-headline-text-decoration: none;
  --moller-type-medium-headline-paragraph-spacing: 2.625rem;
  --moller-type-medium-headline-letter-spacing: 0;
  --moller-type-medium-headline-font-size: 1.75rem;
  --moller-type-medium-headline-line-height: 1.4;
  --moller-type-medium-headline-font-weight: 500;
  --moller-type-medium-headline-font-family: Moller;
  --moller-type-medium-display-text-case: none;
  --moller-type-medium-display-text-decoration: none;
  --moller-type-medium-display-paragraph-spacing: 4.5rem;
  --moller-type-medium-display-letter-spacing: 0;
  --moller-type-medium-display-font-size: 3rem;
  --moller-type-medium-display-line-height: 1.4;
  --moller-type-medium-display-font-weight: 500;
  --moller-type-medium-display-font-family: Moller;
  --moller-type-default-notice-text-case: none;
  --moller-type-default-notice-text-decoration: none;
  --moller-type-default-notice-paragraph-spacing: 1rem;
  --moller-type-default-notice-letter-spacing: 0;
  --moller-type-default-notice-font-size: 1rem;
  --moller-type-default-notice-line-height: 1.4;
  --moller-type-default-notice-font-weight: 500;
  --moller-type-default-notice-font-family: Moller;
  --moller-type-default-label-text-case: none;
  --moller-type-default-label-text-decoration: none;
  --moller-type-default-label-paragraph-spacing: 0.75rem;
  --moller-type-default-label-letter-spacing: 0;
  --moller-type-default-label-font-size: 0.75rem;
  --moller-type-default-label-line-height: 1.4;
  --moller-type-default-label-font-weight: 400;
  --moller-type-default-label-font-family: Moller;
  --moller-type-default-action-text-case: none;
  --moller-type-default-action-text-decoration: none;
  --moller-type-default-action-paragraph-spacing: 1rem;
  --moller-type-default-action-letter-spacing: 0;
  --moller-type-default-action-font-size: 1rem;
  --moller-type-default-action-line-height: 1.4;
  --moller-type-default-action-font-weight: 500;
  --moller-type-default-action-font-family: Moller;
  --moller-type-large-description-text-case: none;
  --moller-type-large-description-text-decoration: none;
  --moller-type-large-description-paragraph-spacing: 0.875rem;
  --moller-type-large-description-letter-spacing: 0;
  --moller-type-large-description-font-size: 0.875rem;
  --moller-type-large-description-line-height: 1.4;
  --moller-type-large-description-font-weight: 400;
  --moller-type-large-description-font-family: Moller;
  --moller-type-large-link-text-case: none;
  --moller-type-large-link-text-decoration: underline;
  --moller-type-large-link-paragraph-spacing: 1rem;
  --moller-type-large-link-letter-spacing: 0;
  --moller-type-large-link-font-size: 1rem;
  --moller-type-large-link-line-height: 1.4;
  --moller-type-large-link-font-weight: 400;
  --moller-type-large-link-font-family: Moller;
  --moller-type-large-body-text-case: none;
  --moller-type-large-body-text-decoration: none;
  --moller-type-large-body-paragraph-spacing: 1rem;
  --moller-type-large-body-letter-spacing: 0;
  --moller-type-large-body-font-size: 1rem;
  --moller-type-large-body-line-height: 1.4;
  --moller-type-large-body-font-weight: 400;
  --moller-type-large-body-font-family: Moller;
  --moller-type-large-lead-text-case: none;
  --moller-type-large-lead-text-decoration: none;
  --moller-type-large-lead-paragraph-spacing: 1.75rem;
  --moller-type-large-lead-letter-spacing: 0;
  --moller-type-large-lead-font-size: 1.75rem;
  --moller-type-large-lead-line-height: 1.4;
  --moller-type-large-lead-font-weight: 400;
  --moller-type-large-lead-font-family: Moller;
  --moller-type-large-overline-text-case: uppercase;
  --moller-type-large-overline-text-decoration: none;
  --moller-type-large-overline-paragraph-spacing: 1.5rem;
  --moller-type-large-overline-letter-spacing: 0;
  --moller-type-large-overline-font-size: 1rem;
  --moller-type-large-overline-line-height: 1.4;
  --moller-type-large-overline-font-weight: 500;
  --moller-type-large-overline-font-family: Moller;
  --moller-type-large-subtitle-text-case: none;
  --moller-type-large-subtitle-text-decoration: none;
  --moller-type-large-subtitle-paragraph-spacing: 2.25rem;
  --moller-type-large-subtitle-letter-spacing: 0;
  --moller-type-large-subtitle-font-size: 1.5rem;
  --moller-type-large-subtitle-line-height: 1.4;
  --moller-type-large-subtitle-font-weight: 500;
  --moller-type-large-subtitle-font-family: Moller;
  --moller-type-large-headline-text-case: none;
  --moller-type-large-headline-text-decoration: none;
  --moller-type-large-headline-paragraph-spacing: 3rem;
  --moller-type-large-headline-letter-spacing: 0;
  --moller-type-large-headline-font-size: 2rem;
  --moller-type-large-headline-line-height: 1.4;
  --moller-type-large-headline-font-weight: 500;
  --moller-type-large-headline-font-family: Moller;
  --moller-type-large-display-text-case: none;
  --moller-type-large-display-text-decoration: none;
  --moller-type-large-display-paragraph-spacing: 5.25rem;
  --moller-type-large-display-letter-spacing: 0;
  --moller-type-large-display-font-size: 3.5rem;
  --moller-type-large-display-line-height: 1.4;
  --moller-type-large-display-font-weight: 500;
  --moller-type-large-display-font-family: Moller;
  --moller-keycolor-interactive: #7142BB;
  --moller-keycolor-info: #407BE8;
  --moller-keycolor-success: #499d5b;
  --moller-keycolor-warning: #e88f00;
  --moller-keycolor-error: #b72929;
  --moller-keycolor-neutral-variant: #407BE8;
  --moller-keycolor-neutral: #f3eee8;
  --moller-keycolor-tertiary-variant: #CE5646;
  --moller-keycolor-tertiary: #E88969;
  --moller-keycolor-secondary: #0000E8;
  --moller-keycolor-primary: #001740;
  --moller-size-4xl: 64px;
  --moller-size-3xl: 48px;
  --moller-size-xxl: 40px;
  --moller-size-xl: 32px;
  --moller-size-l: 24px;
  --moller-size-m: 20px;
  --moller-size-s: 16px;
  --moller-size-xs: 12px;
  --moller-size-xxs: 8px;
  --moller-size-base: 4px;
  --moller-spacing-3xl: 48px;
  --moller-spacing-xxl: 40px;
  --moller-spacing-xl: 32px;
  --moller-spacing-l: 24px;
  --moller-spacing-m: 20px;
  --moller-spacing-s: 16px;
  --moller-spacing-xs: 12px;
  --moller-spacing-xxs: 8px;
  --moller-spacing-base: 4px;
  --moller-spacing-none: 0px;
  --moller-color-highlight: #f2edfa;
  --moller-color-on-info-container: #1d396b;
  --moller-color-info-container: #edf3ff;
  --moller-color-on-info: #ffffff;
  --moller-color-on-success-container: #22492a;
  --moller-color-success-container: #eef7f0;
  --moller-color-on-success: #ffffff;
  --moller-color-on-warning-container: #6b4200;
  --moller-color-warning-container: #fff5e6;
  --moller-color-on-warning: #000000;
  --moller-color-on-error-container: #541313;
  --moller-color-error-container: #faeaea;
  --moller-color-on-error: #ffffff;
  --moller-color-disabled-variant: #ffffff;
  --moller-color-on-loader: #fbfaf8;
  --moller-color-loader: #fefdfd;
  --moller-color-on-surface: #000000;
  --moller-color-surface: #ffffff;
  --moller-color-on-inverse-background: #ffffff;
  --moller-color-inverse-background: #000000;
  --moller-color-on-background: #000000;
  --moller-color-on-tertiary-variant: #000000;
  --moller-color-on-tertiary: #000000;
  --moller-color-on-secondary-container: #00006b;
  --moller-color-on-primary-container: #000b1d;
  --moller-color-on-primary: #ffffff;
  --moller-color-on-tertiary-container: #000000;
  --moller-color-tertiary-container: #fff5f1;
  --moller-color-primary-container: #e6e8ed;
  --moller-color-interactive: #7c49ce;
  --moller-color-info: #3260b5;
  --moller-color-success: #397b47;
  --moller-color-warning: #ff9d00;
  --moller-color-error: #c92d2d;
  --moller-color-on-disabled-variant: #ddd9d3;
  --moller-color-on-surface-variant: #000000;
  --moller-color-surface-variant: #f3eee8;
  --moller-color-outline: #ada9a5;
  --moller-color-on-disabled: #868380;
  --moller-color-disabled: #ddd9d3;
  --moller-color-background: #f9f7f4;
  --moller-color-tertiary-variant: #e25f4d;
  --moller-color-tertiary: #ff9673;
  --moller-color-secondary-container: #e6e6ff;
  --moller-color-on-secondary: #ffffff;
  --moller-color-secondary: #0000ff;
  --moller-color-primary: #001946;
  --moller-radius-checkbox: 0px;
  --moller-radius-feedback: 12px;
  --moller-radius-overlay: 12px;
  --moller-radius-picker: 12px;
  --moller-radius-input: 12px;
  --moller-radius-card: 12px;
  --moller-radius-button: 12px;
  --moller-typeface-text-decoration-strikethrough: line-through;
  --moller-typeface-text-decoration-line: underline;
  --moller-typeface-text-decoration-none: none;
  --moller-typeface-text-case-lowercase: lowercase;
  --moller-typeface-text-case-uppercase: uppercase;
  --moller-typeface-text-case-none: none;
  --moller-typeface-letter-spacing-none: 0;
  --moller-typeface-size-4xl: 3.5rem;
  --moller-typeface-size-3xl: 3rem;
  --moller-typeface-size-xxl: 2rem;
  --moller-typeface-size-xl: 1.75rem;
  --moller-typeface-size-l: 1.5rem;
  --moller-typeface-size-m: 1.25rem;
  --moller-typeface-size-base: 1rem;
  --moller-typeface-size-s: 0.875rem;
  --moller-typeface-size-xs: 0.75rem;
  --moller-typeface-size-xxs: 0.625rem;
  --moller-typeface-weight-bold: 500;
  --moller-typeface-weight-regular: 400;
  --moller-typeface-line-height: 1.4;
  --moller-typeface-brand-display: Moller;
  --moller-typeface-brand: Moller;
  --moller-palette-white: #ffffff;
  --moller-palette-black: #000000;
  --moller-palette-tertiary-variant-95: #FCEFED;
  --moller-palette-tertiary-variant-90: #F6CDC8;
  --moller-palette-tertiary-variant-80: #F2B5AD;
  --moller-palette-tertiary-variant-70: #EC9488;
  --moller-palette-tertiary-variant-60: #E87F71;
  --moller-palette-tertiary-variant-50: #E25F4D;
  --moller-palette-tertiary-variant-40: #CE5646;
  --moller-palette-tertiary-variant-30: #A04337;
  --moller-palette-tertiary-variant-20: #7C342A;
  --moller-palette-tertiary-variant-10: #5f2820;
  --moller-palette-interactive-95: #F2EDFA;
  --moller-palette-interactive-90: #D6C7F0;
  --moller-palette-interactive-80: #C3ABE8;
  --moller-palette-interactive-70: #A785DE;
  --moller-palette-interactive-60: #966DD8;
  --moller-palette-interactive-50: #7C49CE;
  --moller-palette-interactive-40: #7142BB;
  --moller-palette-interactive-30: #583492;
  --moller-palette-interactive-20: #442871;
  --moller-palette-interactive-10: #341F57;
  --moller-palette-info-95: #EDF3FF;
  --moller-palette-info-90: #C6DAFF;
  --moller-palette-info-80: #AAC8FF;
  --moller-palette-info-70: #83AFFF;
  --moller-palette-info-60: #6B9FFF;
  --moller-palette-info-50: #4687FF;
  --moller-palette-info-40: #407BE8;
  --moller-palette-info-30: #3260B5;
  --moller-palette-info-20: #274A8C;
  --moller-palette-info-10: #1D396B;
  --moller-palette-success-95: #eef7f0;
  --moller-palette-success-90: #c9e6cf;
  --moller-palette-success-80: #afd9b8;
  --moller-palette-success-70: #8ac897;
  --moller-palette-success-60: #73bd83;
  --moller-palette-success-50: #50ad64;
  --moller-palette-success-40: #499d5b;
  --moller-palette-success-30: #397b47;
  --moller-palette-success-20: #2c5f39;
  --moller-palette-success-10: #22492a;
  --moller-palette-warning-95: #fff5e6;
  --moller-palette-warning-90: #ffe1b0;
  --moller-palette-warning-80: #ffd28a;
  --moller-palette-warning-70: #ffbd54;
  --moller-palette-warning-60: #ffb133;
  --moller-palette-warning-50: #ff9d00;
  --moller-palette-warning-40: #e88f00;
  --moller-palette-warning-30: #b56f00;
  --moller-palette-warning-20: #8c5600;
  --moller-palette-warning-10: #6b4200;
  --moller-palette-error-95: #faeaea;
  --moller-palette-error-90: #eebebe;
  --moller-palette-error-80: #e69e9e;
  --moller-palette-error-70: #db7272;
  --moller-palette-error-60: #d45757;
  --moller-palette-error-50: #c92d2d;
  --moller-palette-error-40: #b72929;
  --moller-palette-error-30: #8f2020;
  --moller-palette-error-20: #6f1919;
  --moller-palette-error-10: #541313;
  --moller-palette-neutral-variant-95: #EDF3FF;
  --moller-palette-neutral-variant-90: #C6DAFF;
  --moller-palette-neutral-variant-80: #AAC8FF;
  --moller-palette-neutral-variant-70: #83AFFF;
  --moller-palette-neutral-variant-60: #6B9FFF;
  --moller-palette-neutral-variant-50: #4687FF;
  --moller-palette-neutral-variant-40: #407BE8;
  --moller-palette-neutral-variant-30: #3260B5;
  --moller-palette-neutral-variant-20: #274A8C;
  --moller-palette-neutral-variant-10: #1D396B;
  --moller-palette-neutral-95: #FEFDFD;
  --moller-palette-neutral-90: #FBFAF8;
  --moller-palette-neutral-80: #F9F7F4;
  --moller-palette-neutral-70: #F7F4F0;
  --moller-palette-neutral-60: #F5F1ED;
  --moller-palette-neutral-50: #f3eee8;
  --moller-palette-neutral-40: #ddd9d3;
  --moller-palette-neutral-30: #ada9a5;
  --moller-palette-neutral-20: #868380;
  --moller-palette-neutral-10: #666461;
  --moller-palette-tertiary-95: #FFF5F1;
  --moller-palette-tertiary-90: #FFDED4;
  --moller-palette-tertiary-80: #FFCFBF;
  --moller-palette-tertiary-70: #FFB9A1;
  --moller-palette-tertiary-60: #FFAB8F;
  --moller-palette-tertiary-50: #FF9673;
  --moller-palette-tertiary-40: #E88969;
  --moller-palette-tertiary-30: #B56B52;
  --moller-palette-tertiary-20: #8C533F;
  --moller-palette-tertiary-10: #6B3F30;
  --moller-palette-secondary-95: #E6E6FF;
  --moller-palette-secondary-90: #B0B0FF;
  --moller-palette-secondary-80: #8A8AFF;
  --moller-palette-secondary-70: #5454FF;
  --moller-palette-secondary-60: #3333FF;
  --moller-palette-secondary-50: #0000FF;
  --moller-palette-secondary-40: #0000E8;
  --moller-palette-secondary-30: #0000B5;
  --moller-palette-secondary-20: #00008C;
  --moller-palette-secondary-10: #00006B;
  --moller-palette-primary-95: #E6E8ED;
  --moller-palette-primary-90: #B0B8C6;
  --moller-palette-primary-80: #8A95AA;
  --moller-palette-primary-70: #546583;
  --moller-palette-primary-60: #33476B;
  --moller-palette-primary-50: #001946;
  --moller-palette-primary-40: #001740;
  --moller-palette-primary-30: #001232;
  --moller-palette-primary-20: #000E27;
  --moller-palette-primary-10: #000B1D;
  ${globalTextStyles}
    }
`;
export {
  RegisterMollerBilTheme
};
